import { render, staticRenderFns } from "./PaymentMethodCreate.vue?vue&type=template&id=4f4fa8c1"
import script from "../../controllers/payment_method/payment-method-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_method/payment-method-create.js?vue&type=script&lang=js&external"
import style0 from "./PaymentMethodCreate.vue?vue&type=style&index=0&id=4f4fa8c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports